export default __webpack_public_path__ + "static/modal04_02-sp-e7b3632773b3b64a63b199499c3902c7.png";